import { snakeCase } from 'lodash';

import { PropertyMappingTypeEnum } from '../../shared/models';
import { Property, PropertyTypeEnum } from '../../shared/properties/types';

/**
 * Convert a property key to snake_case while preserving dots in nested paths
 */
const toSnakeCaseKey = (key: string): string => {
  if (key.includes('.')) {
    const parts = key.split('.');
    return parts.map((part) => snakeCase(part)).join('.');
  }
  return snakeCase(key);
};

/**
 * Builds a field path for a property, handling both custom and standard properties
 * @param property The property definition
 * @param prefix The prefix to add to the field path (e.g. 'case', 'mainCompany')
 * @returns The constructed field path in snake_case format
 */
export const buildFieldPath = (
  property: Property<PropertyTypeEnum>,
  prefix: string,
): string => {
  if (property.mapping.type === PropertyMappingTypeEnum.custom) {
    return toSnakeCaseKey(`${prefix}.customProperties.${property.mapping.key}`);
  }

  return toSnakeCaseKey(`${prefix}.${property.mapping.key}`);
};
